import React, {useEffect} from 'react'
import {CardActions} from '@mui/material'
import {Button} from '@viptech/react-components'
import {cameraConfigStyles} from '../../CameraConfigBase'
import {useSearchParams} from 'react-router-dom'

type Props = {
  isEditing: boolean
  disabled?: boolean
  isLoading?: boolean
  onCancel?: () => void
  onSubmit?: () => Promise<void> | void
  onEdit?: () => void
}

export default function CameraConfigFooter({isEditing, disabled, isLoading, onCancel, onSubmit, onEdit}: Props) {
  const [searchParams, setSearchParams] = useSearchParams()

  const handleEdit = () => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set('mode', 'update')
    setSearchParams(newParams)
    onEdit?.()
  }

  const handleCancel = () => {
    const newParams = new URLSearchParams(searchParams)
    newParams.delete('mode')
    setSearchParams(newParams)
    onCancel?.()
  }

  const handleSubmit = async () => {
    await onSubmit?.()
    const newParams = new URLSearchParams(searchParams)
    newParams.delete('mode')
    setSearchParams(newParams)
  }

  useEffect(() => {
    const tabParam = searchParams.get('mode')

    if (tabParam && tabParam === 'update') onEdit?.()
  }, [searchParams])

  return isEditing ? (
    <CardActions sx={cameraConfigStyles.cardActions}>
      <Button fontSize='12px' variant='outlined' color='#8E8E8E' height='40px' width='180px' onClick={handleCancel}>
        Cancelar
      </Button>

      <Button fontSize='12px' height='40px' width='180px' onClick={handleSubmit} isLoading={isLoading} disabled={disabled || isLoading}>
        Salvar
      </Button>
    </CardActions>
  ) : (
    <CardActions sx={cameraConfigStyles.cardActions}>
      <Button fontSize='12px' color='#20bc30' hoverColor='#00850e' height='40px' width='180px' onClick={handleEdit}>
        Editar
      </Button>
    </CardActions>
  )
}
